import {Injectable} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, Router} from '@angular/router';
import {MenuItem} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  constructor(private router: Router) {
  }

  buildBreadcrumbs(route: ActivatedRoute): MenuItem[] {
    const breadcrumbs: MenuItem[] = [];
    let currentRoute: ActivatedRoute | null = route.root;
    let url = '';

    while (currentRoute) {
      const routeSnapshot: ActivatedRouteSnapshot = currentRoute.snapshot;
      const children: ActivatedRoute[] = currentRoute.children;

      // Get the route URL segment
      const routeURL = routeSnapshot.url.map(segment => segment.path).join('/');
      if (routeURL) {
        url += `/${routeURL}`;
      }

      if (routeSnapshot.data['parentBreadcrumb']) {
        const parent = routeSnapshot.data['parentBreadcrumb'] as { label: string; routerLink: string };
        // Only add if not already present (to avoid duplicates)
        if (!breadcrumbs.find(b => b.label === parent.label && b.routerLink === parent.routerLink)) {
          breadcrumbs.push(parent);
        }
      }


      // Get the breadcrumb label
      let label: string | undefined;
      const breadcrumb = routeSnapshot.data['breadcrumb'];

      if (typeof breadcrumb === 'function') {
        label = breadcrumb(routeSnapshot); // dynamic
      } else {
        label = breadcrumb; // static
      }

      // If no label, try to get from title or params
      if (!label) {
        label = routeSnapshot.data['title'] ||
          (routeSnapshot.params['projectId'] ? `${routeSnapshot.data['project']['name']}` : undefined);
      }

      if (label && url !== '') {
        breadcrumbs.push({ label, routerLink: url });
      }

      // Move to child route
      currentRoute = children.length > 0 ? children[0] : null;
    }

    return breadcrumbs;
  }
}
